export default __webpack_public_path__ + "static/media/wrong_json_format.cb468d89.png";